import { render } from "./Dashboard.vue?vue&type=template&id=3b030b33&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=3b030b33&scoped=true&lang=css"

import exportComponent from "/harness/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b030b33"]])

export default __exports__